<template>
    <div class="a-modal">
        <div class="popup__header">
            <span class="title title--sm popup__title">{{ id ? $lang('admin.addResponsible.title'): $lang('admin.addResponsible.title2')}}</span>
        </div>
        <form class="form" @submit.prevent="submit" ref="form">
            <div class="popup__content">
                <div class="form__item form__item--inline">
                    <div class="form__inner">
                        <span class="a-filters__name">{{ $lang('admin.addResponsible.partner') }}</span>
                        <el-select :placeholder="$lang('admin.addResponsible.partner.select')"
                                   filterable
                                   :disabled="!!id"
                                   v-model="form.partner_id"
                                   :loading-text="$lang('el-select.loading')"
                                   :noDataText="$lang('el-select.noDataText')"
                                   :noMatchText="$lang('el-select.noMatchText')"
                                   @focus="clearErrors">
                            <el-option v-for="item in partners"
                                       :key="item.user_id"
                                       :label="item.number_name"
                                       :value="item.user_id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="form__inner">
                        <span class="a-filters__name">{{ $lang('admin.addResponsible.master') }}</span>
                        <el-popover v-model="errors.master_id.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="150"
                                    popper-class="add__error-popover"
                                    :content="$lang('admin.addResponsible.master.content')">
                            <el-select :placeholder="$lang('admin.addResponsible.master.select')"
                                       v-model="form.master_id"
                                       :disabled="!!id"
                                       filterable
                                       required
                                       slot="reference"
                                       :loading-text="$lang('el-select.loading')"
                                       :noDataText="$lang('el-select.noDataText')"
                                       :noMatchText="$lang('el-select.noMatchText')"
                                       :class="{ 'add__error': errors.master_id.isErrorPaint }" @focus="clearErrors" >
                                <el-option v-for="item in masters"
                                           :key="item.user_id"
                                           :label="item.id + ' ' + item.user.name"
                                           :value="item.user_id">
                                </el-option>
                            </el-select>
                        </el-popover>
                    </div>
                </div>
                <div class="form__item form__item--medium-margin">
                    <span class="form__label">{{ $lang('admin.addResponsible.respData') }}</span>
                    <el-popover v-model="errors.name.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.name.message">
                        <el-input slot="reference" :class="{ 'add__error': errors.name.isErrorPaint }" @focus="clearErrors"
                                  :placeholder="$lang('admin.addResponsible.name.placeholder')" class="input input--big" v-model="form.name"></el-input>
                    </el-popover>
                </div>
                <div class="form__item form__item--inline">
                    <label class="form__inner">
                        <el-popover :value="errors.phone.isError || errors.phone_md5.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.phone.message || errors.phone_md5.message">
                            <input-phone slot="reference"
                                         :class="{ 'add__error': errors.phone.isErrorPaint || errors.phone_md5.isErrorPaint }"
                                         @focus="clearErrors"
                                         :placeholder="$lang('admin.addResponsible.phone.placeholder')"
                                         class="input input--big"
                                         v-model="form.phone"/>
                        </el-popover>
                    </label>
                    <label class="form__inner">
                        <el-popover :value="errors.email.isError || errors.email_md5.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.email.message || errors.email_md5.message">
                            <el-input slot="reference"
                                      :class="{ 'add__error': errors.email.isErrorPaint || errors.email_md5.isErrorPaint }"
                                      @focus="clearErrors"
                                      :placeholder="$lang('admin.addResponsible.email.placeholder')"
                                      class="input input--big"
                                      v-model="form.email"/>
                        </el-popover>
                    </label>
                </div>
                <div class="form__item form__item--big-margin" v-if="id">
                    <button class="btn btn--small btn--main-bg" :disabled="disableSetPassword" @click.prevent="setNewPassword(id)">{{ $lang('admin.addResponsible.restoreButton') }}</button>
                </div>
                <div class="form__item form__separator">
                    <el-switch :inactive-text="$lang('admin.addResponsible.morePages')"
                               class="switch switch--small switch--label"
                               :active-value="false"
                               :inactive-value="true"
                               v-model="form.has_short_page_limit"/>
                </div>
            </div>
            <div class="popup__footer">
                <button class="btn btn--middle btn--main-bg">{{ $lang('admin.addResponsible.save') }}</button>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import errors from '../../../mixins/errors';
    import userEdit from "../../../mixins/userEdit";
    import InputPhone from "../../../components/InputPhone";
    import Vue from "vue";

    export default {
        name: "AddResponsible",
        mixins: [errors, userEdit],
        components: {InputPhone},
        data: () => ({
            form: {
                name: '',
                email: '',
                phone: '',
                has_short_page_limit: true,
                password: Math.random().toString(36).slice(-8),
                master_id: null,
                partner_id: null,
                id: null,
            },
            errors: {
                name: {
                    isError: false,
                    message: ''
                },
                email: {
                    isError: false,
                    message: ''
                },
                email_md5: {
                    isError: false,
                    message: ''
                },
                phone: {
                    isError: false,
                    message: ''
                },
                phone_md5: {
                    isError: false,
                    message: ''
                },
                master_id: {
                    isError: false,
                    message: ''
                },
            }
        }),
        computed: {
            ...mapState('auth',[
                'user'
            ]),
            ...mapState('pages',[
                'partners',
                'masters'
            ]),
            id() {
                return this.$route.params.id;
            }
        },
        created() {
            if (this.id) {
                this.getUser(this.id)
                    .then((response) => {
                        this.setData(
                            'form',
                            ['id', 'name', 'email', 'phone', 'master_id', 'partner_id', 'has_short_page_limit'],
                            response.data,
                            ['id', 'name', 'email', 'phone', 'master_id', 'partner_id', 'has_short_page_limit']
                        );
                    })
            }
        },
        mounted() {
            this.getPartnersList();
            this.getMastersList();

            if (this.$route.params.responsible) {
                this.form.email = this.$route.params.responsible.email;
                this.form.phone = this.$route.params.responsible.phone;
                this.form.name = this.$route.params.responsible.name;
                this.form.id = this.$route.params.responsible.id;
            }
        },
        watch: {
            'form.partner_id': {
                handler: function (val) {
                    if (!val) {
                        return false;
                    }

                    this.getMastersList(val);

                    if (!this.id) {
                        this.form.master_id = undefined;
                    }
                },
                deep: true
            }
        },
        methods: {
            ...mapActions('pages', [
                'getPartnersList',
                'getMastersList',
                'getAllMasters',
            ]),
            ...mapActions('user', [
                'createUser',
                'editUser',
                'getUser',
                'resetPassword',
            ]),
            submit() {
                this.$loading(this.$optionsLoading);

                if (this.id) {
                    this.edit();
                } else {
                    this.create();
                }
            },
            create() {
                this.createUser(this.form)
                    .then((response) => {
                        this.$appNotify.success(Vue.prototype.$lang('admin.addResponsible.success'));
                        this.$refs.form.reset();
                        this.$router.push({name:'responsibles'});
                    }).catch((error) => {
                        this.createErrors(error.response.data.errors);
                    }).finally(() => {
                        this.$loading({}).close();
                    });
            },
            edit() {
                this.editUser(this.form)
                    .then((response) => {
                        this.setData(
                            'form',
                            ['name', 'email', 'phone', 'master_id', 'partner_id', 'has_short_page_limit'],
                            response.data,
                            ['name', 'email', 'phone', 'master_id', 'partner_id', 'has_short_page_limit']
                        );

                        this.$appNotify.success(Vue.prototype.$lang('admin.addResponsible.success'));
                        this.$refs.form.reset();
                        this.$router.push({name:'responsibles'});
                    }).catch((error) => {
                        this.createErrors(error.response.data.errors);
                    }).finally(() => {
                        this.$loading({}).close();
                    });
            },
        }
    }
</script>
